function Ojcover() {
	if($('.listPickup').length) {
		$(".listPickup li").each(function(index){
			var image = new Image();
			image.src = $(this).find('.imgFix').attr("src");
			var widthImage=image.naturalWidth;
			if( widthImage >= 260) {
				$(".listPickup li").eq(index).addClass('oj-cover');
			}
			else {
				$(".listPickup li").eq(index).removeClass('oj-cover');
			}
		});
	}
}

$(document).ready(function() {
	Ojcover();
});
